module.exports = __webpack_public_path__ + "static/media/hamb-menu.3315e212.svg";